import { useQuery } from "react-query";
import { departmentsApi, type Department } from "@/lib/api/departments";

export const DEPARTMENTS_QUERY_KEY = ["departments"] as const;

export function useDepartments(includeInactive = true, options?: { enabled?: boolean }) {
  return useQuery<Department[]>(
    [...DEPARTMENTS_QUERY_KEY, includeInactive],
    () => departmentsApi.getAll(includeInactive),
    { staleTime: 60 * 60 * 1000, enabled: options?.enabled ?? true }
  );
}
